module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Reign-Of-Fire.049ee88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Reign-Of-Fire.jpg
// module id = 1YJW
// module chunks = 0